// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"BasAgentsCard_innerContainer__2UDe4","basAgentsInfo":"BasAgentsCard_basAgentsInfo__2ZuuN","title":"BasAgentsCard_title__2FAla","data":"BasAgentsCard_data__ABZeo"};